<script>
    import Top from "./Top.svelte";
    import Characteristics from "./Characteristics.svelte";
    import Features from "./Features.svelte";
    import Testimonials from "./Testimonials.svelte";
    import CorePrinciples from "./CorePrinciples.svelte";
    import News from "./News.svelte";
    import FandQ from "./FandQ.svelte";
    import ContactForm from "./ContactForm.svelte";
</script>

<div class="font-geist bg-cream" style="overflow-x: clip; background-color: #fafafa;">
    <section id="top" style="padding-top: 0; padding-bottom: 0;">
        <Top />
    </section>

    <section id="characteristics" style="padding-top: 60px; padding-bottom: 60px;">
        <Characteristics />
    </section>

    <section id="features">
        <Features />
    </section>

    <section id="testimonials">
        <Testimonials />
    </section>

    <section id="CorePrinciples">
        <CorePrinciples />
    </section>

    <section id="news">
        <News />
    </section>

    <section id="pricing" class="w-full" style="background-color: #fafafa; padding: 0;">
        <h2 class="font-semibold text-[38px] text-navy text-center pricing-heading tracking-tight">Plans and pricing</h2>
        <div class="w-full pricing-bottom">
            <stripe-pricing-table
                pricing-table-id="prctbl_1QCfaGAnHQme9GY61y9EgGJP"
                publishable-key="pk_live_51PyTlIAnHQme9GY6dje7mRSTC1tXhUSjX8lfDBc3XpBQ26AKUw6lezjc4P7VOJJMkE0SP4wnRGSu08TEmycdPEms002yaz9jbz"
            />
        </div>
    </section>

    <section id="contact">
        <ContactForm />
    </section>

    <section id="F&Q">
        <FandQ />
    </section>
</div>

<style>
    section {
        padding-top: 100px;
        padding-bottom: 100px;
    }
    .pricing-heading {
        padding-top: 100px;
        padding-bottom: 80px;
    }
    .pricing-bottom {
        padding-bottom: 100px;
    }
    @media (max-width: 768px) {
        section {
            padding-top: 48px;
            padding-bottom: 48px;
        }
        .pricing-heading {
            padding-top: 48px;
            padding-bottom: 40px;
        }
        .pricing-bottom {
            padding-bottom: 48px;
        }
    }
</style>
